import { tryGet } from './index';

export const getRoles = async () => {
  const result = await tryGet('/roles?');
  return result.data;
};